import LandingDescription from "./LandingDescription"
import LandingImage from "./LandingImage"
import Marquee from "./Marquee"

const FirstSection = () => {
    return <div className="first-section">
        <LandingImage />
        <LandingDescription />
    </div>
}

export default FirstSection